module.exports = [
    '$scope',
    '$rootScope',
    '$routeParams',
function (
    $scope,
    $rootScope,
    $routeParams
) {
    $scope.surveyId = $routeParams.id;
    $scope.actionType = $routeParams.action;
}];



// WEBPACK FOOTER //
// ./app/settings/surveys/edit.controller.js